import { styled, Typography } from "@mui/material";
import { Lock, Person } from "@mui/icons-material";
import { Form, Link, useNavigation } from "react-router-dom";
import AuthContainer from "../AuthContainer";
import { COLORS } from "../../../ui/Theme";
import useResponsive from "../../../components/hooks/useResponsive";
import AuthTextfield from "../AuthTextfield";
import AuthTextfieldLabel from "../AuthTextfieldLabel";
import Loading from "../../../components/loader/Loading";

const CustomBox = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  width: "100%",
  gap: "6px",
});

const Login = () => {
  const { isSm } = useResponsive();
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";

  return (
    <AuthContainer>
      <Form
        action="/login"
        method="post"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          backgroundColor: "#fff",
          padding: isSm ? "40px" : "30px",
          gap: 20,
          border: "1px solid #EEEEEE",
          borderRadius: "12px",
          borderColor: "#EEEEEE",
          minWidth: "390px",
        }}
      >
        <Typography
          sx={{ fontSize: "20px", fontWeight: 400 }}
        >
          به{" "}
          <Typography
            component="span"
            sx={{
              color: COLORS.BLUE,
              fontSize: "20px",
              fontWeight: 700,
            }}
          >
            پرتفویار
          </Typography>{" "}
          خوش آمدید
        </Typography>

        {/*username (phone)*/}
        <CustomBox>
          <AuthTextfieldLabel label="نام کاربری (شماره موبایل)" />
          <AuthTextfield
            type="text"
            name="username"
            placeholder="شماره موبایل"
            icon={<Person sx={{ color: "#BDBDBD" }} />}
          />
        </CustomBox>

        {/*password*/}
        <CustomBox>
          <AuthTextfieldLabel label="رمز عبور" />
          <AuthTextfield
            type="password"
            name="password"
            placeholder="رمز عبور"
            icon={<Lock sx={{ color: "#BDBDBD" }} />}
          />
        </CustomBox>

        <button
          className="btn btn-blue"
          type="submit"
          style={{
            fontWeight: 700,
            color: "#FAFAFA",
            borderRadius: "12px",
          }}
        >
          {isSubmitting ? <Loading color="#fff" /> : "ورود"}
        </button>
      </Form>
      <Typography
        sx={{ fontSize: "14px", fontWeight: 400, color: COLORS.BLACK }}
      >
        <span>در پرتفویار اکانت ندارید؟</span>{" "}
        <Link
          to={"/signup"}
          style={{ fontSize: "14px", fontWeight: 900, color: COLORS.BLUE }}
        >
          ثبت نام
        </Link>
      </Typography>
      <Link
        to={"/forgot-password"}
        style={{ fontSize: "14px", fontWeight: 900, color: COLORS.BLUE }}
      >
        رمز خود را فراموش کردید؟
      </Link>
    </AuthContainer>
  );
};

export default Login;
